import { useState } from 'react'

// example
// const { isModalVisible, showModal, hideModal } = useModal()
//
// <Modal visible={isModalVisible} onCancel={hideModal} width={"80%"}>
//   <KpiModalContent record={record} dashboard={dashboard} kpi={kpi} nextStepKpi={nextStepKpi} period={period} />
// </Modal>
//

export function useModal<T>(isDefaultVisible = false) {
  const [isModalVisible, setIsModalVisible] = useState(isDefaultVisible)
  const [content, setContent] = useState<T | undefined>(undefined)
  const showModal = (content?: T) => {
    setIsModalVisible(true)
    setContent(content)
  }
  const hideModal = () => {
    setIsModalVisible(false)
    setContent(undefined)
  }

  return {
    isModalVisible,
    showModal,
    hideModal,
    setContent,
    content,
  }
}
